namespace $.$$ {
	export class $shm_list_page extends $.$shm_list_page {

		@ $mol_mem
		add( next?: ( ( event: Event )=> unknown ) | null ) {
			return next ?? null
		}

		@ $mol_mem
		close( next?: ( ( event: Event )=> unknown ) | null ) {
			return next ?? null
		}

		add_content() {
			return this.add() ? [ this.List_head().Add() ] : []
		}

		close_content() {
			return this.close() ? [ this.List_head().Close() ] : []
		}

		@ $mol_action
		add_run( event?: Event ) {
			if( event ) this.add()?.( event )
			return event ?? null
		}

		@ $mol_action
		close_run( event?: Event ) {
			if( event ) this.close()?.( event )
			return event ?? null
		}
	}
}
